export default [
    { language: "ro", lang: "ro" },
    { language: "en", lang: "en" },
    { language: "es", lang: "es" },
    { language: "it", lang: "it" },
];
